/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/Auth'
// import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  return (

    <div className='px-3'>
      <button type="button"  className="btn" onClick={logout} style={{backgroundColor:"#6D9300",color:'white'}}>
       Logout
       <i className='ki-solid ki-exit-right text-light fs-2'  style={{ paddingLeft: "10px" }}></i> 
     </button>
   
    </div>
  )
}

export {HeaderUserMenu}